import React from "react";

export default function ZdAlert({ icon, textcolor, titleColor, title, children }) {
  return (
    <>
      <div>
        <div className="flex items-center">
          <span>{icon}</span>
          <span style={{ color: titleColor }} className="font-semibold ml-[8px]">
            {title}
          </span>
        </div>
        <div className="mt-[3px] text-[16px] pl-6" style={{ color: textcolor }}>
          {children}
        </div>
      </div>
    </>
  );
}
